<template>
  <v-container fluid>
    <v-row>
      <v-col>
        <component :is="titleTag" class="mb-1">
          {{ title }}
        </component>
      </v-col>
    </v-row>
    <v-row>
      <v-col
        v-for="(group, key) in visibleGroups"
        :key="key"
        :cols="cols"
        :sm="sm"
        :md="md"
        :lg="lg"
        :xl="xl"
      >
        <tiles-group
          :title="group.title"
          :links="group.links"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import TilesGroup from '@/components/ui/TilesGroup.vue'

  export default {
    name: 'TilesPage',
    components: { TilesGroup },
    props: {
      title: { type: String, required: true },
      linkGroups: { type: Array, required: true },
      titleTag: { type: String, default: 'h1' },
      cols: { type: [String, Number], default: 12 },
      sm: { type: [String, Number], default: undefined },
      md: { type: [String, Number], default: undefined },
      lg: { type: [String, Number], default: undefined },
      xl: { type: [String, Number], default: undefined },
    },
    computed: {
      visibleGroups () {
        return this.linkGroups
          .filter((g) => !g.permissions || this.userCan(g.permissions))
          .map((g) => ({
            ...g,
            links: (g.links || []).filter((l) => !l.permissions || this.userCan(l.permissions)),
          }))
          .filter((g) => g.links.length > 0)
      },
    },
  }
</script>
